import { createFileRoute } from "@tanstack/react-router";

import { ProductCreatePage } from "../../../../features/catalog/product-create-page";

export const Route = createFileRoute("/_app/catalog/products/new")({ component: ProductCreatePage });
